/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @emails oncall+relay
 * @format
 */
// flowlint ambiguous-object-type:error
'use strict';

var _require = require('../query/GraphQLTag'),
    getUpdatableQuery = _require.getUpdatableQuery;

var _require2 = require('../store/RelayStoreUtils'),
    getArgumentValues = _require2.getArgumentValues;

var _require3 = require('./createUpdatableProxy'),
    createUpdatableProxy = _require3.createUpdatableProxy;

var nonUpdatableKeys = ['id', '__id', '__typename', 'js'];

function readUpdatableQuery_EXPERIMENTAL(query, variables, proxy) {
  var updatableQuery = getUpdatableQuery(query);
  return {
    updatableData: createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy)
  };
}

module.exports = {
  readUpdatableQuery_EXPERIMENTAL: readUpdatableQuery_EXPERIMENTAL
};